export enum ETripType {
    Import = 1,
    Export = 2,
    Domestic = 3
}


// WEBPACK FOOTER //
// ./src/app/enums/trip-type.ts